import { Controller } from "@hotwired/stimulus"
import Sortable from 'sortablejs';
import { createAlert } from '../scripts/createAlert';

export default class extends Controller {
  static targets = [ "container", "saveButton", "question", "form", "sortable" ]
  static values = {
    interview: Number,
    story: Number
  }

  updateQuestionNumbers() {
    const cards = this.containerTarget.querySelectorAll('.question-sortable')
    Array.from(cards).forEach((card, idx) => {
      const label = card.querySelector('[data-question-number]')
      if (label) label.textContent = idx + 1
    })
  }

  connect() {
    // console.log("Hello, Stories Interview Controller here!", this.element)
    // console.log(this.containerTarget)
    // console.log(this.saveButtonValue)
    // console.log(this.questionValue)

    this.sortableTargets.forEach(elm => {
      Sortable.create(elm, {
        draggable: '.question-sortable',
        dataIdAttr: 'data-sortable-id',
        handle: ".sortable-handle",  // Drag handle selector within list items

        // Changed sorting within list
        onUpdate: (event) => {
          const rows = event.target.querySelectorAll('.row.question-sortable');
          const attachmentIds = Array.from(rows).map(elm => elm.dataset.attachmentId)

          const token = $('meta[name="csrf-token"]').attr('content');
          $.ajaxSetup({
            beforeSend: function (xhr) {
              xhr.setRequestHeader('X-CSRF-Token', token);
            }
          });

          $.post(`/stories/${this.storyValue}/interviews/${this.interviewValue}/questions/reorder`, { ordered_question_ids: attachmentIds }).then(() => {
            createAlert('success', 'Question order updated')
          })

          this.updateQuestionNumbers()
        }
      });
    })

    this.updateQuestionNumbers()
  }

  addQuestion(event) {
    if (event.target.classList.contains('disabled')) {
      return;
    }

    fetch(`/stories/${this.storyValue}/interviews/${this.interviewValue}/questions/new`).then(res => res.text()).then(partial => {
      this.containerTarget.insertAdjacentHTML( 'beforeend', partial );

      // add focus to newly created input
      this.questionTargets[this.questionTargets.length - 1].querySelector('input').focus();

      if (this.questionTargets.length >= 3) {
        this.saveButtonTarget.removeAttribute('disabled');
      }

      this.updateQuestionNumbers()
    });
  }

  deleteUnsavedQuestion(event) {
    event.preventDefault();
    const question = event.target.closest('.question-sortable');

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
    const questionId = question?.dataset?.attachmentId

    // If the question has an ID (e.g. auto-created during recording), delete it from the backend.
    if (questionId) {
      fetch(`/stories/${this.storyValue}/interviews/${this.interviewValue}/questions/${questionId}`, {
        method: 'DELETE',
        headers: {
          'X-CSRF-Token': csrfToken,
          'Accept': 'application/json'
        }
      }).then(() => {
        question.remove();
        createAlert('success', 'Question removed')
        this.updateQuestionNumbers()
      }).catch(() => {
        createAlert('danger', 'Unable to remove question')
      })
      return
    }

    question.remove();
    createAlert('success', 'Question removed')
    this.updateQuestionNumbers()
  }

  attemptSubmit(event) {
    // when submitting, need to make sure each question has at least a single response mode selected
    event.preventDefault();

    var valid = true, responseModeErrorMessage, textErrorMessage, errorMessage;
    this.questionTargets.forEach(question => {

      let questionValid = true;
      let responseModes = Array.from(question.querySelectorAll('.video-response, .audio-response, .text-response'));
      if (responseModes.every(elm => !elm.checked)) {
        question.querySelector('.question-text').classList.add('is-invalid');
        responseModeErrorMessage = 'Please select at least one response mode for each question.'
        valid = false;
        questionValid = false;
      }

      if (question.querySelector('.question-text').value === '') {
        question.querySelector('.question-text').classList.add('is-invalid');
        textErrorMessage = 'Please make sure all questions have text before saving.'
        valid = false;
        questionValid = false;
      }

      if (questionValid) {
        question.querySelector('.question-text').classList.remove('is-invalid');
      }
    });

    if (valid) {
      this.formTarget.submit();
    } else {
      if (textErrorMessage && responseModeErrorMessage) {
        errorMessage = "Please make sure all fields are filled out before saving."
      } else {
        errorMessage = textErrorMessage || responseModeErrorMessage
      }

      createAlert('danger', errorMessage)
    }
  }
}
